import SkeletonCustom from '@/components/_common/SkeletonCustom';
import StatisticDashboard, {
  StatisticDashboardModule,
  StatisticDashboardTypeColor,
} from '@/components/_common/StatisticDashboard';
import WorkOrdersListModal from '@/components/_common/WorkOrdersListModal';
import { useDashboardQuick } from '@/core/domain/workorder/Dashboard/Dashboard.hooks';
import { DashboardType } from '@/core/domain/workorder/Dashboard/Dashboard.types';
import { WorkOrderComplementStatusNumber } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { useDisclosure } from '@/hooks';
import { DateTimeFormat } from '@/utils/moment';
import formatterPrice from '@/utils/number/formatterPrice';
import { Col, Row } from 'antd';
import moment from 'moment';
import React from 'react';

const StatisticEstimatorView: React.FC = () => {
  const [viewWorkOrdersFilterClosedOpen, viewWorkOrdersFilterClosedActions] =
    useDisclosure();
  const [
    viewWorkOrdersFilterDateClosedOpen,
    viewWorkOrdersFilterDateClosedActions,
  ] = useDisclosure();
  const [
    viewWorkOrdersDeliveriesInTheMonthOpen,
    viewWorkOrdersDeliveriesInTheMonthActions,
  ] = useDisclosure();
  const [
    viewWorkOrdersLateDeliveriesOpen,
    viewWorkOrdersLateDeliveriesActions,
  ] = useDisclosure();

  const { data, isLoading } = useDashboardQuick({
    dashboardType: DashboardType.workOrder,
  });

  return (
    <SkeletonCustom loading={isLoading} skeletonType="INPUT" skeletonCount={4}>
      <Row gutter={[24, 24]} justify="space-between">
        <Col>
          <StatisticDashboard
            tooltipTitle="Calculamos essa métrica dividindo o valor total dos orçamentos fechados pela quantidade correspondente desses orçamentos."
            statisticTitle="Total ticket médio"
            statisticValue={formatterPrice(data?.averageTicketTotal || 0)}
            color={StatisticDashboardTypeColor.income}
            onClick={viewWorkOrdersFilterClosedActions.open}
            dashboardModule={StatisticDashboardModule.workOrder}
          />
        </Col>

        <Col>
          <StatisticDashboard
            tooltipTitle="Esta métrica é obtida ao dividir o valor total dos orçamentos fechados e autorizados no mês atual pela quantidade correspondente desses orçamentos."
            statisticTitle={`Total ticket médio | ${moment()
              .format('MMM')
              .toUpperCase()}`}
            statisticValue={formatterPrice(data?.averageTicketMonth || 0)}
            color={StatisticDashboardTypeColor.expense}
            onClick={viewWorkOrdersFilterDateClosedActions.open}
            dashboardModule={StatisticDashboardModule.workOrder}
          />
        </Col>

        <Col>
          <StatisticDashboard
            tooltipTitle="Quantidade de orçamentos com data de saida previsa para o mês atual."
            statisticTitle={`Entregas para ${moment()
              .format('MMM')
              .toUpperCase()}`}
            statisticValue={String(data?.deliveryMonth || 0)}
            color={StatisticDashboardTypeColor.info}
            onClick={viewWorkOrdersDeliveriesInTheMonthActions.open}
            dashboardModule={StatisticDashboardModule.workOrder}
          />
        </Col>

        <Col>
          <StatisticDashboard
            tooltipTitle="Quantidade de orçamentos com data de saida prevista anterior ao mês atual onde o orçamento ainda está em aberto e autorizado"
            statisticTitle="Entregas em atraso"
            statisticValue={String(data?.deliveryExpired || 0)}
            color={StatisticDashboardTypeColor.expense}
            onClick={viewWorkOrdersLateDeliveriesActions.open}
            dashboardModule={StatisticDashboardModule.workOrder}
          />
        </Col>
      </Row>

      <WorkOrdersListModal
        open={viewWorkOrdersFilterClosedOpen}
        onCancel={viewWorkOrdersFilterClosedActions.close}
        queryFilter={{
          status: [WorkOrderComplementStatusNumber.Closed],
          onlyFirstComplements: true,
        }}
      />

      <WorkOrdersListModal
        open={viewWorkOrdersFilterDateClosedOpen}
        onCancel={viewWorkOrdersFilterDateClosedActions.close}
        queryFilter={{
          status: [
            WorkOrderComplementStatusNumber.Closed,
            WorkOrderComplementStatusNumber.Authorized,
          ],
          authorizationInitialDate: moment()
            .startOf('month')
            .format(DateTimeFormat),
          authorizationFinalDate: moment()
            .endOf('month')
            .format(DateTimeFormat),
          closingInitialDate: moment().startOf('month').format(DateTimeFormat),
          closingFinalDate: moment().endOf('month').format(DateTimeFormat),
          onlyFirstComplements: true,
        }}
      />

      <WorkOrdersListModal
        open={viewWorkOrdersDeliveriesInTheMonthOpen}
        onCancel={viewWorkOrdersDeliveriesInTheMonthActions.close}
        queryFilter={{
          estimatedLeaveInitialDate: moment()
            .startOf('month')
            .format(DateTimeFormat),
          estimatedLeaveFinalDate: moment()
            .endOf('month')
            .format(DateTimeFormat),
        }}
      />

      <WorkOrdersListModal
        open={viewWorkOrdersLateDeliveriesOpen}
        onCancel={viewWorkOrdersLateDeliveriesActions.close}
        queryFilter={{
          status: [
            WorkOrderComplementStatusNumber.Open,
            WorkOrderComplementStatusNumber.Authorized,
          ],
          estimatedLeaveFinalDate: moment()
            .subtract(1, 'day')
            .format(DateTimeFormat),
        }}
      />
    </SkeletonCustom>
  );
};

export default StatisticEstimatorView;
